<template>
    <div class="loading-container">
        <span></span>
    </div>
</template>

<script>
    export default {
        name: 'jabra-progress-linear',
        data: function () {
            return {}
        },
        computed: {}
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    $initial-loading-bar-width: 60px;
    $initial-total-width: 120px;
    .loading-container {
        width: $initial-total-width;
        height: 8px;
        margin: 30px;
        position: relative;
        overflow: hidden;
        background: lighten($accent-1, 10%);
        > span {
            display: block;
            height: 100%;
            width: $initial-loading-bar-width;
            background-color: $accent-1;
            position: relative;
            left: -$initial-loading-bar-width;
            animation: scroll 3s infinite;
        }
    }

    @keyframes scroll {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX($initial-total-width + ($initial-loading-bar-width * 2));
        }
    }
</style>
